var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCircle4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#3CDD9F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 26.5,
    fill: "#3CDD9F",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.017 42.256H30.19v-3.094l7.41-11.57h3.536v11.856h2.678v2.808h-2.678V46h-3.12v-3.744zm0-10.244h-.052l-4.602 7.436h4.654v-7.436z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjM3LjUiIGZpbGw9IiMzQ0REOUYiLz4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjI2LjUiIGZpbGw9IiMzQ0REOUYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMzguMDE2NiA0Mi4yNTZIMzAuMTkwNlYzOS4xNjJMMzcuNjAwNiAyNy41OTJINDEuMTM2NlYzOS40NDhINDMuODE0NlY0Mi4yNTZINDEuMTM2NlY0NkgzOC4wMTY2VjQyLjI1NlpNMzguMDE2NiAzMi4wMTJIMzcuOTY0NkwzMy4zNjI2IDM5LjQ0OEgzOC4wMTY2VjMyLjAxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgGreenCircle4 as ReactComponent };